module.exports = __webpack_public_path__ + "img/s7bLogo4.1a92a1c4.svg";